import { useScopedTranslate } from '@locale/translate';

import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { useFlowNodes } from 'ui/traveller-journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'add_to_journey';

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={node.data?.description}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Add traveller to journey',
  },
};
